export default class DisplayEvent extends Event {
  public detail: { isImageDisplayed: boolean };
  constructor(type: string, isImageDisplayed: boolean) {
    super(type);
    this.detail = { isImageDisplayed };
  }
}
